import { render, staticRenderFns } from "./StatDeposit.vue?vue&type=template&id=0028935d&scoped=true&"
import script from "./StatDeposit.vue?vue&type=script&lang=js&"
export * from "./StatDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0028935d",
  null
  
)

export default component.exports